import { render, staticRenderFns } from "./CrearTipoDispositivoModal.vue?vue&type=template&id=b5798256&"
import script from "./CrearTipoDispositivoModal.vue?vue&type=script&lang=ts&"
export * from "./CrearTipoDispositivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports